<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9" class="d-flex justify-start align-center"><h2>File</h2></v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-btn color="primary" small depressed @click="$router.push({ name: 'files-add' })">Tambah</v-btn>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title><h5>Filter</h5></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-text-field label="Cari" outlined dense :hide-details="true" v-model="search" />
            </v-col>
            <v-col cols="4">
              <v-select
                :hide-details="true"
                :items="statuses"
                outlined
                dense
                item-text="name"
                item-value="value"
                v-model="selectedStatus"
                label="Status"
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" small @click="getData" depressed>Filter</v-btn>
          <v-btn
            color="primary"
            small
            depressed
            outlined
            class="ml-3"
            @click="
              search = ''
              selectedStatus = ''
              getData()
            "
            >Reset</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="data"
        :options.sync="options"
        :server-items-length="total"
        :loading="loadingTable"
        class="elevation-1"
        :items-per-page="limit"
        :footer-props="{
          'items-per-page-options': [5, 10, 50, 100],
        }"
      >
        <template v-slot:[`item.image`]="{ item }">
          <v-img :src="item.image" width="100" class="ma-3" height="100"></v-img>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status == 1 ? 'Aktif' : 'Tidak Aktif' }}
        </template>
        <template v-slot:[`item.option`]="{ item }">
          <v-btn color="warning" x-small :to="`/files/${item.id}`">Ubah</v-btn>
          <v-btn
            color="error"
            class="ml-3"
            x-small
            @click="
              deleteData = item
              deleteDialog = true
            "
            >Hapus</v-btn
          >
        </template>
      </v-data-table>
    </v-col>

    <v-snackbar v-model="alert.status" :timeout="timeout" :color="alert.success ? 'success' : 'error'" right bottom>
      {{ alert.message }}
    </v-snackbar>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title>Yakin dihapus?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div>
            <v-btn
              color="error"
              small
              depressed
              class="mr-2"
              :loading="loadingDeleteButton"
              :disabled="loadingDeleteButton"
              @click="deleteAction"
              >Ya</v-btn
            >
            <v-btn color="error" outlined depressed small @click="deleteDialog = false">Tidak</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mdiSquareEditOutline, mdiDotsVertical, mdiRefresh, mdiFileOutline } from '@mdi/js'
import axios from 'axios'

export default {
  setup() {
    return {
      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiRefresh,
        mdiFileOutline,
      },
    }
  },
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'))
    },
  },
  data() {
    return {
      alert: {
        status: false,
        success: false,
        message: '',
      },
      timeout: 1200,
      loadingTable: false,
      statuses: [
        { name: 'Pilih Semua', value: '' },
        { name: 'Aktif', value: 1 },
        { name: 'Tidak Aktif', value: 0 },
      ],
      search: '',
      selectedStatus: '',
      total: 0,
      limit: 10,
      data: [],
      headers: [
        { text: '#', value: 'image', sortable: false },
        { text: 'Nama', value: 'name', sortable: false },
        { text: 'URL', value: 'seo_url', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Dilihat', value: 'viewed', sortable: false },
        { text: 'Opsi?', value: 'option', sortable: false },
      ],
      options: {},
      deleteDialog: false,
      loadingDeleteButton: false,
      deleteData: {},
    }
  },
  mounted() {
    this.getData()
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    },
  },
  methods: {
    getData() {
      this.loadingTable = true
      const token = localStorage.getItem('token')
      const { page, itemsPerPage } = this.options
      const params = {
        page,
        limit: itemsPerPage,
        q: this.search,
        status: this.selectedStatus ?? '',
      }
      const paramsString = new URLSearchParams(params).toString()
      axios
        .get(`${process.env.VUE_APP_API_ENDPOINT}files?${paramsString}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.loadingTable = false
          if (res.status == 200) {
            const data = res.data
            if (data.success) {
              this.total = data.data.count
              this.data = data.data.rows
            } else {
              this.alert = {
                status: true,
                success: false,
                message: data.message,
              }
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
        })
        .catch(err => {
          this.loadingTable = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
    deleteAction() {
      this.loadingDeleteButton = true
      const token = localStorage.getItem('token')
      axios
        .delete(`${process.env.VUE_APP_API_ENDPOINT}files/${this.deleteData.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(res => {
          this.loadingDeleteButton = false
          this.deleteDialog = false
          if (res.status == 200) {
            const data = res.data
            this.alert = {
              status: true,
              success: data.success,
              message: data.message,
            }
          } else {
            this.alert = {
              status: true,
              success: false,
              message: res.statusText,
            }
          }
          this.getData()
        })
        .catch(err => {
          this.loadingDeleteButton = false
          this.deleteDialog = false
          const response = err.response
          const data = response.data
          this.alert = {
            status: true,
            success: false,
            message: data.message,
          }
          if (data.message == 'Anda tidak diberikan akses!') {
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            this.$router.push({ name: 'login' })
          }
        })
    },
  },
}
</script>

<style>
</style>